<template>
    <data-dialog
        :dialog-title="dialog.title"
        :closeOnClickModal = 'false'
        :is-visible="dialog.formVisible"
        ref="skDialog"
        style="height: 70vh"
        :is-read="dialog.isRead"
        @dgVerifyDeal="dgVerifyDeal('skDialog','dialog')"
        @dgCancelDeal='cancel'
        @dgConfirmDeal="save">
      <div slot="dialogFrom">
        <el-form ref="dialog" :model="dialog.data" :rules="dialogRule"  label-width="130px" label-position="top" class="commonForm">
          <el-row>
            <el-col :span="12">
              <el-form-item label="水库代码" prop="rescd" style="width: 70%;" >
                <el-input :disabled="dialog.isReadOrEdit" v-model="dialog.data.rescd"  placeholder="请输入水库代码" maxlength="30" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="水库名称" prop="name" style="width: 70%;">
                    <el-input v-model="dialog.data.name"  placeholder="请输入水库名称" maxlength="30" />
                </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="序号" prop="no" style="width: 70%;">
                <el-input v-model="dialog.data.no" controls-position="right" :min="0" :maxlength="10" :pattern="pattern" @input="handleInput" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </data-dialog>


</template>

<script>
  import DataDialog from "@/components/tableGather/dataDialog.vue";
    import md5 from 'js-md5'
    export default {
        name: "skOpen",
        components:{
          DataDialog
        },
        data(){
            var validatePass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入密码'));
                }else if(this.mmForm.oldMm === value){
                    callback(new Error('新旧密码不能一致!'));
                } else {
                    if(value.length < 5){
                       callback(new Error('长度在 6 到 30 个字符'));
                    }
                    if (this.mmForm.checkMm !== '') {
                        this.$refs.mmForm.validateField('checkMm');
                    }
                    callback();
                }
            };
            var validatePass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请再次输入密码'));
                } else if (value !== this.mmForm.newMm) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };
            // 设置手机号的验证规则
          var phoneRules = (rule, value, callback) => {
            if (!value) {
              callback()
            } else {
              const reg = /^1[3|4|5|6|7|8][0-9]\d{8}$/;
              if (reg.test(value)) {
                callback();
              } else {
                return callback(new Error("请输入正确的电话"));
              }
            }
          };
          // 设置qq的验证规则
          var qqRules = (rule, value, callback) => {
            if (!value) {
              callback()
            } else {
              const reg =  /^[1-9][0-9]{4,10}$/;
              if (reg.test(value)) {
                callback();
              } else {
                return callback(new Error("请输入正确的QQ号码"));
              }
            }
          };
          // 设置email的验证规则
          var checkEmail = (rule, value, callback) => {
            if (!value) {
              callback()
            }else {
              const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/
              // if (!value) {
              //     return callback(new Error('邮箱不能为空'))
              // }
              setTimeout(() => {
                if (mailReg.test(value)) {
                  callback()
                } else {
                  callback(new Error('请输入正确的邮箱格式'))
                }
              }, 100)
            }
          };
          // 设置传真的验证规则
          var faxRules = (rule, value, callback) => {
            if (!value) {
              callback()
            } else {
              const reg =  /(\(\d{3,4}\)|\d{3,4}-|\s)?\d{8}/;
              if (reg.test(value)) {
                callback();
              } else {
                return callback(new Error("请输入正确的传真"));
              }
            }
          };
          // 设置电话的验证规则
          var telephoneRules = (rule, value, callback) => {
            if (!value) {
              callback()
            } else {
              const reg =  /(\(\d{3,4}\)|\d{3,4}-|\s)?\d{8}/;
              if (reg.test(value)) {
                callback();
              } else {
                return callback(new Error("请输入正确的电话"));
              }
            }
          };
            return{
              pattern: /^\d{0,10}$/,
              ifAdd:false,
              innerVisible:false,
              categoryOptions:[],
                dialogRule:{
                    rescd:[
                      { required: true, message: '请输入水库代码', trigger: 'blur' },
                    ],
                    name: [
                        { required: true, message: '请输入水库名称', trigger: 'blur' },
                    ],

                },

                mmForm: {
                    oldMm:'',
                    newMm:'',
                    checkMm: '',
                },
                oldMm:"",
                mmRules:{
                    oldMm: [
                        { required: true, message: '请输入旧密码', trigger: 'blur' },
                      /*  { min: 4, max:30,message: '长度在 6 到 30 个字符', trigger: 'blur' }*/
                    ],
                    newMm: [
                        {validator:validatePass,trigger:'blur'}
                    ],
                    checkMm: [
                        { validator: validatePass2, trigger: 'blur' }
                    ],
                },
            }

        },
      mounted() {
        this.getcategoryOptions();

      },
      methods:{
        handleInput(){
          // 使用正则表达式检查输入的值是否为数字
          this.dialog.data.no = this.dialog.data.no.replace(/\D/g, '');
          // 如果输入超过10个字符，截取前10个字符
          if (this.dialog.data.no.length > 9) {
            this.dialog.data.no = this.dialog.data.no.slice(0, 9);
          }
        },
        dgVerifyDeal(dgRef, frRef) {
          this.$refs[frRef].validate((valid) => {
            if (valid) {
              this.$refs[dgRef].isShowPop(true);
            } else {
              this.$refs[dgRef].isShowPop(false);
            }
          });
        },
        getcategoryOptions() {
            this.request.get('rm-sdictionary/v1/query/04').then(res => {
              if (res.ok) {
                if (res.data != null) {
                  this.jcMcOptions = [];
                  for (let i = 0; i < res.data.length; i++) {
                    this.categoryOptions.push({
                      code: res.data[i]['code'],
                      name: res.data[i]['name'],
                    });
                  }
                } else {
                  this.$message.info("获取水库分类数据为空");
                }
              } else {
                this.$message.error(res.error.message);
              }
            });
          },
          cancel(){
            this.$emit("reset")
            this.dialog.formVisible = false
            //重置表单值
            this.$refs.dialog.resetFields();
          },
          categoryCodeSelect(){},
          save(event){
            this.$refs.dialog.validate((valid) => {
                if (valid) {

                    if(this.dialog.title === '新增水库'){
                      const dataPar = {
                        rescd : this.dialog.data.rescd,
                        name : this.dialog.data.name,
                        no:this.dialog.data.no
                      }
                        this.request.post("/rm-bres/v1", dataPar).then(res => {
                            if (res.ok) {
                                this.dialog.formVisible = false
                                this.$emit("reset")
                                this.$message.success("添加水库完成！")
                            }else{
                              this.$message.error(res.error.message)
                            }
                        })
                    }else{
                      //console.log('update',this.dialog.data)
                        this.request.put("/rm-bres/v1", this.dialog.data).then(res => {
                            if (res.ok) {
                                this.dialog.formVisible = false
                                this.$emit("reset")
                                this.$message.success("修改水库完成！")
                            }
                        })
                    }
                }
            })

          },
            handleClose(done) {
                this.$confirm('确认关闭？')
                    .then(_ => {
                        done();
                    })
                    .catch(_ => {});
            },
            getMm(){
                this.mmForm={
                  oldMm:'',
                  newMm:'',
                  checkMm: ''
                }
                this.innerVisible = true
            },

            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                            const data = {
                                id:this.dialog.data.id,
                                oldPassword:md5(this.mmForm.oldMm) ,
                                newPassword:md5(this.mmForm.newMm),
                                checkPassword:md5(this.mmForm.checkMm)
                            }
                            this.request.put("/rm-suser/v1/modifyPass", data).then(res => {
                                if(res.ok){
                                    this.$message.success("密码修改成功！")
                                }else{
                                    this.$message.error(res.error)
                                }
                                this.innerVisible = false
                            })

                    } else {
                        return false;
                    }
                });
            },

        },
        props:['dialog']
    }
</script>
<style scoped>
    .commonForm {
      padding-top: 4vh;
      padding-left: 6vh;
    }
    .el-divider--horizontal{
        margin: 12px 0;
    }
    /*选择日期，年份的隐藏 */
    .picker-dateNoneYear {
      .el-date-picker__header {
        span:nth-child(3) { /*第三个标签是span的标签，把它隐藏*/
          display: none;
        }
        button:nth-child(1) {
          display: none;
        }
        button:nth-child(5) {
          display: none;
        }
      }
    }

</style>
